import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

export function RequireAuth() {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="loading-shell">Loading workspace…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}
